import React from 'react'
import { Tooltip } from '@material-ui/core'
import { SubCategoryContainer } from './styled'

export default class SubCategoryCell extends React.Component {
  render() {
    const { title, description, onClick } = this.props
    return (
      <Tooltip title={description} placement='top'>
        <SubCategoryContainer onClick={onClick}>
          {title}
        </SubCategoryContainer>
      </Tooltip>
    )
  }
}